import React from 'react';
import ReactTooltip from 'react-tooltip';
import copy from "copy-to-clipboard";
import { secondsToTime } from "../../Helpers/parse";
import { useContext } from 'react';
import { GlobalContext } from '../../Context/GlobalContext'
import { Route } from 'react-router-dom/cjs/react-router-dom.min';


const BASE_URL = "https://imd0mxanj2.execute-api.us-west-2.amazonaws.com/ssr/watch"
// renders a container with the timed stamped captions 
const AgendaItem = ({ item, curentTime, scrubTo, color, url, video }) => {
  const {darkMode} = useContext(GlobalContext)
  let [state, setState] = React.useState({ open: false, copied: false });

  const hexToRgbA = (hex, opacity) => {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opacity +
        ")"
      );
    }
    return "rgba(0,0,0,0)";
  };
  let captions = item.captions.map((caption) => {
    return (
      <div 
        key={caption.text + caption.start}
        className="dt caption-item"
        style={{
          backgroundColor:
            caption.start <= curentTime && caption.end >= curentTime
              ? hexToRgbA(color, 0.16)
              : "transparent",
        }}
        onClick={() => scrubTo(caption.start)}
      >
        {caption.text}
      </div>
    );
  });
  
    let hyperlinks = item.hyperlinks
      ? item.hyperlinks.map((hyperlink) => {
          return (
            <div key={hyperlink.text + hyperlink.hasOwnProperty('link') ? hyperlink.link : hyperlink.url}>
              <button
                className="btn btn-sm btn-link btn-block"
                onClick={() => {
                  let externalLink = hyperlink.hasOwnProperty('link') ? hyperlink.link : hyperlink.url;
                  if (!/(http|https):\/\//i.test(externalLink)) {
                    externalLink = `https://${externalLink}`;
                  } else if (/^http:\/\//i.test(externalLink)) {
                    externalLink = externalLink.replace(/^http:\/\//i, 'https://');
                  };
                  window.open(externalLink, "_blank");
                }}
              > 
                {hyperlink.text}
              </button>
            </div>
          );
        })
      : [];
    return (
      <li 
        className={ " list-group-item  " + (curentTime >= item.time ? " agenda-selected-v2" : "")}
        style={{ cursor: "pointer", borderRightColor: item.time < curentTime ? color : ""}}
      >
        
        <div>
            {/* Title of time stamp */}
          <div style={{ color: 'black' }} onClick={() => {scrubTo(item.time);}}>
            {item.title}
          </div>

            {/* Caption Text */}
          <div className={"dt"} onClick={() => {scrubTo(item.time)}}>
            {item.text}
          </div>
  
          <div className={"dt"} onClick={() => { scrubTo(item.time)}}>
            {secondsToTime(item.time)}
          </div>
          
          <div>{hyperlinks}</div>
  
          <div className="flex-row">
            {/* <span className="transcript-btn">transcript</span> */}
            <span className="transcript-btn"
                  onClick={() => {setState({ ...state, open: !state.open })}}>
              <>
                <i className="fas fa-closed-captioning fa-dm" data-tip data-for="closedCaptions"></i>
                <ReactTooltip id="closedCaptions" type="dark" effect="solid">
                  <span>Closed Captions</span>
                </ReactTooltip>
              </>
            </span>
            <span className="transcript-btn"
                  onClick={() => {
                    setState({ ...state, copied: true });
                    let copy_url = `${BASE_URL}/${video}?page=HOME&start=${item.time}`;
                    copy(copy_url);
                  }}>
  
              <>
                <i className={"fas fa-sm" + (state.copied ? " fa-check-circle" : " fa-link")}
                   data-tip
                   data-for="transcriptButton"
                ></i>
                <ReactTooltip id="transcriptButton" type="dark" effect="solid">
                  <span>Copy Video Section</span>
                </ReactTooltip>
              </>
            </span>
  
            <span className="transcript-btn" onClick={() => {scrubTo(item.time)}}>
              <>
                <i className="fas fa-play-circle fa-sm" data-tip data-for="playVideoSection"></i>
                <ReactTooltip id="playVideoSection" type="dark" effect="solid">
                  <span>Play Video Section</span>
                </ReactTooltip>
              </>
            </span>
          </div>
          <div className={state.open ? "d-flex caption-box" : "d-none"}
               style={{ flexDirection: "column" }}>
            <input className="caption-box-search d-none" placeholder="Search" />
            {captions}
          </div>
        </div>
        {/* <span className={item.time < curentTime ? "d-flex" : "d-none"}>
          <i className="fas fa-check-circle text-success"></i>
        </span> */}
      </li>
    );
  };
  
export default AgendaItem;
  
